<template>

  <div>
    <van-nav-bar
      title="我的预约"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-field
      label-width="110"
      v-model="phone"
      label="输入手机号查询"
      maxlength="11"
      minlength="11"
      center
      clearable
      type="number"
      placeholder="请输入登记的手机号"
    >
      <template #button>
        <van-button solot="button" @click="get_list()" icon="search" size="small" type="primary">检索</van-button>
      </template>
    </van-field>
    <div style="width: 100%;margin-top:10px;" v-if="myList.length > 0">
      <div style="height: 10px"></div>
      <div class="card_box" v-for="(item,index) in myList" :key="index">
        <div class="card_body">
          <van-field :value="item.Id" :readonly="true" label="续约序号"/>
          <van-field :value="showName(item.status)" :readonly="true" label="当前状态"/>
          <van-field :value="item.orderDate === null ? '等待排床':item.orderDate" :readonly="true" label="预约日期"/>
          <van-field :value="item.name" :readonly="true" label="患者姓名"/>
          <van-field :value="item.age" :readonly="true" label="患者年龄"/>
          <van-field :value="item.phone" :readonly="true" label="联系电话"/>
          <van-field :value="item.types" :readonly="true" label="疾病名称"/>
          <van-field :value="item.area" :readonly="true" label="预约院区"/>
          <van-field v-if="item.doctorName" :value="item.doctorName" :readonly="true" label="预约医生"/>
          <van-field :value="item.room" :readonly="true" label="病房类型"/>
          <van-field label="其他操作" v-if="(item.status === 0 || item.status === 4) && item.is_expire">
            <template slot="input">
              <van-button type="primary" @click="changeDate(index)">修改日期</van-button>
              <span style="width: 10px"></span>
              <van-button type="danger" @click="cancelDate(index)">取消预约</van-button>
            </template>
          </van-field>
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无预约信息"/>

    <bed-choose :area="area" ref="bedChoose" @onChoose="onChooseArea"/>

  </div>

</template>


<script>

import BedChoose from '@/components/BedChoose'

export default {
  beforeCreate: function () {

  },
  components: {
    BedChoose
  },
  data() {
    return {
      phone: '',
      myList: [],
      doctorList: [],
      is_loaded: 0,
      area: null,
      index: -1
    }
  },
  created: function () {

  },
  mounted: function () {
  },
  methods: {
    showName(v) {
      if (v === 0) {
        return '已预约'
      }
      if (v === 2) {
        return '已取消'
      }
      if (v === 1) {
        return '已手术'
      }
      if (v === 3) {
        return '保守'
      }
      if (v === 4) {
        return '未排期'
      } else {
        return '-'
      }
    },
    onClickLeft() {
      this.$router.replace({
        name: 'index'
      })
    },
    get_list() {
      if (this.phone && this.phone !== '' && this.phone.length < 11) {
        this.$toast.fail('请输入正确的手机号码');
      }
      let self = this;
      this.$http.post('/client/my', {
        phone: self.phone
      }).then(function (response) {
        console.log(response)
        if (response.data.code === 0) {
          self.myList = response.data.data
        } else {
          self.$toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeDate(idx) {
      this.index = idx
      this.area = this.myList[idx].area
      this.$refs['bedChoose'].onShow()
    },

    async cancelDate(idx) {
      let _this = this
      this.index = idx
      this.$dialog.confirm({
        title: '确认取消',
        message: '取消后系统将自动释放您的预约，如需预约必须重新提交',
        closeOnPopstate: false,
      }).then(async () => {
        // on confirm
        if (this.index > -1) {
          let item = this.myList[this.index]
          let res = await _this.$http.post('/client/cancel', {
            Id: item.Id
          })
          _this.$toast(res.data.msg);
          _this.get_list()
        }

      }).catch(() => {
        // on cancel
      });


    },
    async onChooseArea(v) {
      let _this = this
      this.$dialog.confirm({
        title: '确认变更',
        message: '变更后系统将自动释放您的当前日期',
        closeOnPopstate: false,
      }).then(async () => {
        // on confirm

        if (this.index > -1) {
          let item = this.myList[this.index]
          let res = await this.$http.post('/client/arrange_handle', {
            Id: item.Id,
            orderDate: v.orderDate
          })
          console.log(res)
          this.$toast(res.data.msg);
          _this.get_list()
        }

      }).catch(() => {
        // on cancel
      });


    }
  }
}


</script>

<style scoped>
.appointment_title {
  font-weight: 300;
  text-align: center;
}

.loading_box {
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.card_box {
  overflow: hidden;
  position: relative;
  background: #fff;
  font-size: 14px;
}

.card_header_box {
  display: flex;
  padding: 6px 16px;
  align-items: center;
}

.card_header_left {
  flex: 1;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
}

.card_header_right {
  flex: 1;
  text-align: right;
  color: #80848f;
}

.card_body {
  position: relative;
  padding: 6px 16px;
  color: #495060;
  float: left;
  width: calc(100% - 32px);
  margin-top: .5rem;
  border-bottom: 1px solid #f2f2f2;
}

.card_footer {
  position: relative;
  padding: 6px 16px;
  color: #80848f;
  float: left;
  width: calc(100% - 32px);
  text-align: left;
  font-size: 0.875rem;
}

.body_des {
  margin-bottom: 10px;
}


.load-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto;

}

.boxLoading {
  width: 50px;
  height: 50px;
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

}

.boxLoading:before {
  content: "";
  width: 50px;
  height: 5px;
  background: #000;
  opacity: 0.1;
  position: absolute;
  top: 59px;
  left: 0;
  border-radius: 50%;
  animation: shadow 0.5s linear infinite;
}

.boxLoading:after {
  content: "";
  width: 50px;
  height: 50px;
  background: #00adb5;
  animation: animate 0.5s linear infinite;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 3px;
}

@keyframes animate {
  17% {
    border-bottom-right-radius: 3px;
  }
  25% {
    transform: translateY(9px) rotate(22.5deg);
  }
  50% {
    transform: translateY(18px) scale(1, 0.9) rotate(45deg);
    border-bottom-right-radius: 40px;
  }
  75% {
    transform: translateY(9px) rotate(67.5deg);
  }
  100% {
    transform: translateY(0) rotate(90deg);
  }
}

@keyframes shadow {
  0%,
  100% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.2, 1);
  }
}


</style>



// WEBPACK FOOTER //
// src/views/my.vue